import React, { useRef, useState } from 'react';
import { Button, useTheme, Icon, Popover } from '@material-ui/core';
import { get, size } from 'global/lib/lodash';
import useStyles from './styles';
import { getColorFromScore } from 'global/styles';
import getDisplayScore from 'global/utils/getDisplayScore';
import clsx from 'clsx';

export default (props) => {
  const variant = get(props, 'variant', 'normal');
  const options = get(props, 'options', []);
  const scorecardConfig = get(props, 'scorecardConfig');
  const getHighlight = get(props, 'getHighlight', null);
  const { selected } = props;
  const theme = useTheme();
  const classes = useStyles({ variant });
  const [anchorEl, setAnchorEl] = useState(null);
  const buttonRef = useRef();
  const ignoreConfigColor = get(scorecardConfig, 'ignoreColor', true);

  const open = Boolean(anchorEl);

  const btnPress = (e, opt, i) => {
    const onPress = get(props, 'onSelect', () => 0);
    onPress(opt, i);
    setAnchorEl(null);
  };

  const getColorFromValue = (val, isSelected = false) => {
    const color = getColorFromScore(val, scorecardConfig && !ignoreConfigColor ? [scorecardConfig.minScore || 0, scorecardConfig.maxScore || 100] : undefined);
    return {
      borderColor: color,
      backgroundColor: isSelected ? color : undefined,
      color: isSelected ? theme.palette.getContrastText(color) : undefined,
    };
  };

  const getIconFromIndex = (i) => {
    const icons = ['close', 'check', 'indeterminate_check_box'];
    return icons[i];
  };

  if (size(options) > 6) {
    const currentSel = options[selected];
    const label = get(currentSel, 'label', '');

    return (
      <div className={classes.container}>
        <Button
          ref={buttonRef}
          aria-controls="simple-menu"
          aria-haspopup="true"
          onClick={(e) => setAnchorEl(buttonRef.current)}
          style={currentSel && getColorFromValue(get(currentSel, 'value'), currentSel)}
          className={clsx(classes.btn, classes.btnSelected)}
        >
          <span className={classes.optNumber}>{getDisplayScore(currentSel, selected, scorecardConfig)}</span>
          <span className={classes.btnText}>{getHighlight ? getHighlight(label) : label}</span>
          <span style={{ marginLeft: 'auto', marginTop: 5 }}>
            <Icon>arrow_drop_down</Icon>
          </span>
        </Button>

        <Popover
          anchorEl={anchorEl}
          open={open}
          onClose={() => setAnchorEl(null)}
          anchorOrigin={{
            horizontal: 0,
            vertical: 0,
          }}
          elevation={0}
        >
          <div style={{ width: get(anchorEl, 'clientWidth', 0) + 5 }}>
            {options.map((opt, i) => {
              const isSelected = opt.index === selected;
              return (
                <Button key={i} onClick={(e) => btnPress(e, opt, opt.index)} style={getColorFromValue(opt.value, isSelected)} className={clsx(classes.btn, isSelected && classes.btnSelected)}>
                  {variant === 'passFail' ? <Icon className={classes.icon}>{getIconFromIndex(i)}</Icon> : <span className={classes.optNumber}>{getDisplayScore(opt, i, scorecardConfig)}</span>}
                  <span className={classes.btnText}>{getHighlight ? getHighlight(opt.label) : opt.label}</span>
                </Button>
              );
            })}
          </div>
        </Popover>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      {options.map((opt, i) => {
        const isSelected = opt.index === selected;
        return (
          <Button key={i} onClick={(e) => btnPress(e, opt, opt.index)} style={getColorFromValue(opt.value, isSelected)} className={clsx(classes.btn, isSelected && classes.btnSelected)}>
            {variant === 'passFail' ? <Icon className={classes.icon}>{getIconFromIndex(i)}</Icon> : <span className={classes.optNumber}>{getDisplayScore(opt, i, scorecardConfig)}</span>}
            <span className={classes.btnText}>{getHighlight ? getHighlight(opt.label) : opt.label}</span>
          </Button>
        );
      })}
    </div>
  );
};
